import { useState, useEffect } from 'react';

export function Popup() {
  const [isFlutterInAppWebViewReady, setIsFlutterInAppWebViewReady] = useState(false);

  const handleListener = () => {
    setIsFlutterInAppWebViewReady(true);
  };
  useEffect(() => {
    window.addEventListener('flutterInAppWebViewPlatformReady', handleListener);

    return () => window.removeEventListener('flutterInAppWebViewPlatformReady', handleListener);
  }, []);
  return (
    <div className="popup-overlay" id="popup">
      <div className="popup">
        <h2>An error has occurred!</h2>
        <p>Please try again later or go back to the previous page.</p>
        <button
          onClick={() => {
            console.log('isFlutterInAppWebViewReady', isFlutterInAppWebViewReady);
            console.log('window?.flutter_inappwebview', window?.flutter_inappwebview);

            if (isFlutterInAppWebViewReady) {
              window?.flutter_inappwebview &&
                window?.flutter_inappwebview?.callHandler('DesignHub', 'onBackButtonClicked');
              console.log('click back');
            }
          }}
        >
          Go Back
        </button>
      </div>
    </div>
  );
}
